import { render, staticRenderFns } from "./KeineDaten.vue?vue&type=template&id=4de40fad&scoped=true&"
import script from "./KeineDaten.vue?vue&type=script&lang=js&"
export * from "./KeineDaten.vue?vue&type=script&lang=js&"
import style0 from "./KeineDaten.vue?vue&type=style&index=0&id=4de40fad&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4de40fad",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
installComponents(component, {VAlert})
